// The API answers 403 "accountNotProvisioned" when the Auth0 account matches no organization:
// every request will fail the same way, so the app shows a dedicated screen instead of alerts.
export const isAccountNotProvisionedError = (error) =>
  error?.response?.status === 403 &&
  Array.isArray(error.response.data?.errors) &&
  error.response.data.errors.some((err) => err.code === "accountNotProvisioned");
